module.exports = __webpack_public_path__ + "img/currency-euro-circle.bd10c46f.svg";